export enum SplitType {
    None = 0,
    SplitEvenly = 1,
    SplitByPercentage = 2,
    SplitByAmount = 3,
    SplitByItem = 4,
    SplitBySeat = 5
}